<script>
  import Vue from 'vue';
  import router from '@/router';

  import ModalBlank from '@/plugins/modals/ModalBlank.vue';
  import ModalPlayGame from '@/components/ModalPlayGame.vue';

  const OfferMobile = () => import(/* webpackChunkName: "OfferMobile" */'./OfferMobile.vue');
  const Offer = () => import(/* webpackChunkName: "Offer" */'./Offer.vue');

  const CasinoMobile = () => import(/* webpackChunkName: "CasinoMobile" */'./CasinoMobile.vue');
  const Casino = () => import(/* webpackChunkName: "Casino" */'./Casino.vue');

  const SupplierMobile = () => import(/* webpackChunkName: "SupplierMobile" */'./SupplierMobile.vue');
  const Supplier = () => import(/* webpackChunkName: "Supplier" */'./Supplier.vue');

  const GamesPlay = () => import(/* webpackChunkName: "GamesPlay" */'./GamesPlay.vue');  

  let routeName = null;
  let parentComponent = null;
  let component = null;
  let mobileComponent = null;

  export default {
    name: 'RouterHandler',
    functional: true,

    beforeRouteEnter (to, from, next) {
      routeName = to.name.toLowerCase();

      let getParentComponent = router.getMatchedComponents()[0];

      if (getParentComponent && getParentComponent.name !== 'RouterHandler') {
        parentComponent = getParentComponent;
      } else if (!parentComponent) {
        parentComponent = Vue.prototype.$mq('sm-max') ? mobileComponent : component;
      }

      switch (routeName) {
        case 'offer':
          mobileComponent = OfferMobile;
          component = Offer;
          break;

        case 'casino':
          mobileComponent = CasinoMobile;
          component = Casino;
          break;

        case 'supplier':
          mobileComponent = SupplierMobile;
          component = Supplier;
          break;

        case 'play':
          mobileComponent = GamesPlay;
          component = GamesPlay;
          break;

        default:
          throw 'No route component provided'
      }

      next();
    },

    render: function(h, context) {
      // TEMPORARY GAME PLAY LOGIC TO FIRE MODAL FROM ANY ROUTE
      // WILL BE REMOVE/UPDATED ONCE GAMES IS UPDATED
      if (routeName === 'play') {
        if (parentComponent) {
          const PlayGameModal = {
            name: 'PlayGameModal',
            functional: true,

            render: (h, { data }) => {
              return h(ModalPlayGame, {
                ...data,
                props: context.props,
                class: `c-modal--play-game`
              });
            }
          };

          // Use nextTick to avoid infinite render loop
          Vue.prototype.$nextTick(() => {
            Vue.prototype.$modal.add(PlayGameModal);
          })
        }

        return h(parentComponent || mobileComponent, context.data, context.children);

      } else if (Vue.prototype.$mq('sm-max')) {
        // If parent component exists, load component in modal
        if (parentComponent) {
          const MobileModal = {
            name: 'MobileModal',
            functional: true,

            render: (h, { data }) => {
              return h(ModalBlank, {
                ...data,
                on: {
                  close: () => router.back()
                },
                class: `c-modal--mobile c-modal--${ routeName }`
              }, [
                h(mobileComponent, context)
              ]);
            }
          };

          // Use nextTick to avoid infinite render loop
          Vue.prototype.$nextTick(() => {
            Vue.prototype.$modal.add(MobileModal);
          })
        }

        // Mobile
        return h(parentComponent || mobileComponent, context.data, context.children);
      } else {
        // Desktop
        // Reset parent component incase game play is next route
        parentComponent = null;
        return h(component, context.data, context.children);
      }
    }    
  };
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/pages/RouteHandler.vue